import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, Zap, History, MoreHorizontal, BarChart3 } from "lucide-react";
import { useState } from "react";
import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";

// 直接导入子页面组件
import TradeLogs from "./TradeLogs";
import Signals from "./Signals";
import Records from "./Records";
import Reports from "./Reports";

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center py-20">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}

export default function More() {
  const [activeTab, setActiveTab] = useState("reports");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold flex items-center gap-2">
          <MoreHorizontal className="h-5 w-5 text-primary" />
          更多功能
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          盈亏报表、交易日志、交易信号、交易记录等辅助功能
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full max-w-2xl grid-cols-4">
          <TabsTrigger value="reports" className="text-xs">
            <BarChart3 className="h-3.5 w-3.5 mr-1.5" />
            盈亏报表
          </TabsTrigger>
          <TabsTrigger value="trade-logs" className="text-xs">
            <FileText className="h-3.5 w-3.5 mr-1.5" />
            交易日志
          </TabsTrigger>
          <TabsTrigger value="signals" className="text-xs">
            <Zap className="h-3.5 w-3.5 mr-1.5" />
            交易信号
          </TabsTrigger>
          <TabsTrigger value="records" className="text-xs">
            <History className="h-3.5 w-3.5 mr-1.5" />
            交易记录
          </TabsTrigger>
        </TabsList>

        <TabsContent value="reports" className="mt-4">
          <Reports />
        </TabsContent>

        <TabsContent value="trade-logs" className="mt-4">
          <TradeLogs />
        </TabsContent>

        <TabsContent value="signals" className="mt-4">
          <Signals />
        </TabsContent>

        <TabsContent value="records" className="mt-4">
          <Records />
        </TabsContent>
      </Tabs>
    </div>
  );
}
